import { Loading, TitleController } from '@pandiafi/design-system'
import { DateTime } from 'luxon'
import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next'

import { DataLoader } from './PaymentHistoryDataLoader'
import { ErrorHandler } from './PaymentHistoryErrorHandler'
import { PaymentMonth, PaymentMonthVariant } from './PaymentMonth/PaymentMonth'

const resolvePaymentMonthVariant = (
  yearMonth: string,
  currentMonth: DateTime
): PaymentMonthVariant => {
  const paymentMonth = DateTime.fromFormat(yearMonth, 'yyyy-MM')

  if (paymentMonth.hasSame(currentMonth.plus({ months: 1 }), 'month')) {
    return 'next'
  }
  if (paymentMonth > currentMonth) {
    return 'future'
  }
  if (paymentMonth.hasSame(currentMonth, 'month')) {
    return 'current'
  }

  return 'history'
}

export const PaymentHistory: React.FC = () => {
  const { t } = useTranslation(['common', 'payments', 'titles'])
  const currentMonth = DateTime.now().startOf('month')

  return (
    <TitleController title={t('titles:paymentHistory')}>
      <Suspense fallback={<Loading variant="details" />}>
        <ErrorHandler>
          <DataLoader>
            {({ paymentsByMonth, remittances }) => {
              // A withholding is listed under its target's month but paid on its own date
              const withholdings = paymentsByMonth.flatMap(
                (month) => month.withholdingsUsed
              )

              return (
                <div>
                  {paymentsByMonth.map((month, index) => (
                    <PaymentMonth
                      key={month.yearMonth}
                      index={index}
                      month={month}
                      remittances={remittances}
                      withholdings={withholdings}
                      variant={resolvePaymentMonthVariant(
                        month.yearMonth,
                        currentMonth
                      )}
                    />
                  ))}
                </div>
              )
            }}
          </DataLoader>
        </ErrorHandler>
      </Suspense>
    </TitleController>
  )
}
